var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/lorem/index.js
// module id = 1575
// module chunks = 0